export default {
    // host: 'http://webapi.irongguang.com',
    host: 'http://47.111.248.240:9002',
    codeHost: 'http://localhost:8088',
    // imageHost: 'http://webapi.irongguang.com',
    imageHost: 'http://api.chetsh.com',
    appId: '1003604205986484250',
    version: '1.0.0',
    platform: 'Airwork-Admin',
    loginPath: '/login/index'
};

//scp -r dist/ root@47.103.108.192:/usr/local/www/airwork-tmp
// password: irg_gobi2019

// ssh root@47.103.108.192
// sudo -s
// cd /usr/local/www
// rm -rf airwork-admin/*
// mv /usr/local/www/airwork-tmp/dist/* /usr/local/www/airwork-admin


// WEBPACK FOOTER //
// ./src/common/application.js